export default {
    listener(admin) {
        Echo.private(`admin-${admin.profile.id}`)
            .listen('.local_presence_purchase', (event) => {
                VueEvent.fire('LOCAL_PRESENCE_PURCHASE', event)
            })
            .listen('.local_presence_upgrade', (event) => {
                VueEvent.fire('LOCAL_PRESENCE_UPGRADE', event)
            })
            .listen('.compliance_bundle_operation_done', (event) => {
                VueEvent.fire('COMPLIANCE_BUNDLE_OPERATION_DONE', event)
            })
    }
}
